__turbopack_context__.v({
  "disableTransition": "Sidebar-module-scss-module__-zn5Pq__disableTransition",
  "hierarchicalMenuCount": "Sidebar-module-scss-module__-zn5Pq__hierarchicalMenuCount",
  "hierarchicalMenuLink": "Sidebar-module-scss-module__-zn5Pq__hierarchicalMenuLink",
  "hierarchicalMenuList": "Sidebar-module-scss-module__-zn5Pq__hierarchicalMenuList",
  "hierarchicalMenuRoot": "Sidebar-module-scss-module__-zn5Pq__hierarchicalMenuRoot",
  "hierarchicalMenuSelectedItemLink": "Sidebar-module-scss-module__-zn5Pq__hierarchicalMenuSelectedItemLink",
  "mobileSidebarCloseButton": "Sidebar-module-scss-module__-zn5Pq__mobileSidebarCloseButton",
  "mobileSidebarSeeAll": "Sidebar-module-scss-module__-zn5Pq__mobileSidebarSeeAll",
  "noRefinementRoot": "Sidebar-module-scss-module__-zn5Pq__noRefinementRoot",
  "refinementListCheckbox": "Sidebar-module-scss-module__-zn5Pq__refinementListCheckbox",
  "refinementListCount": "Sidebar-module-scss-module__-zn5Pq__refinementListCount",
  "refinementListDisabledShowMore": "Sidebar-module-scss-module__-zn5Pq__refinementListDisabledShowMore",
  "refinementListItem": "Sidebar-module-scss-module__-zn5Pq__refinementListItem",
  "refinementListLabel": "Sidebar-module-scss-module__-zn5Pq__refinementListLabel",
  "refinementListLabelText": "Sidebar-module-scss-module__-zn5Pq__refinementListLabelText",
  "refinementListList": "Sidebar-module-scss-module__-zn5Pq__refinementListList",
  "refinementListRoot": "Sidebar-module-scss-module__-zn5Pq__refinementListRoot",
  "refinementListSearchBox": "Sidebar-module-scss-module__-zn5Pq__refinementListSearchBox",
  "refinementListshowMore": "Sidebar-module-scss-module__-zn5Pq__refinementListshowMore",
  "searchBoxRoot": "Sidebar-module-scss-module__-zn5Pq__searchBoxRoot",
  "searchSidebar": "Sidebar-module-scss-module__-zn5Pq__searchSidebar",
  "searchSidebarContainer": "Sidebar-module-scss-module__-zn5Pq__searchSidebarContainer",
  "searchSidebarContainerOpen": "Sidebar-module-scss-module__-zn5Pq__searchSidebarContainerOpen",
  "searchSidebarInnerWrapper": "Sidebar-module-scss-module__-zn5Pq__searchSidebarInnerWrapper",
});
